import React from "react";
import { Loader2 } from "lucide-react";

export function Spinner({ label }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-ink-soft">
      <img src="/logo.png" alt="FlatTribe" className="h-9 w-auto animate-pulse" />
      <Loader2 className="h-6 w-6 animate-spin text-brand" />
      {label && <p className="text-sm">{label}</p>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, sub, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-3xl bg-white px-6 py-14 text-center shadow-card">
      {Icon && <div className="grid h-14 w-14 place-items-center rounded-2xl bg-brand-light"><Icon className="h-6 w-6 text-brand" /></div>}
      <h4 className="font-heading text-lg font-bold text-ink">{title}</h4>
      {sub && <p className="max-w-xs text-sm text-ink-soft">{sub}</p>}
      {action}
    </div>
  );
}

export function SectionHeader({ title, sub, action }) {
  return (
    <div className="mb-3 flex items-end justify-between">
      <div>
        <h3 className="font-heading text-xl font-extrabold tracking-tight text-ink">{title}</h3>
        {sub && <p className="text-sm text-ink-soft">{sub}</p>}
      </div>
      {action}
    </div>
  );
}
